export default __webpack_public_path__ + "media/zurb/img/events/wired/family-giving/fg-2-b7b64089fbbcd8899442d123208c1f6d.jpg";